import { render, staticRenderFns } from "./TestArea.vue?vue&type=template&id=249083f7&scoped=true&"
import script from "./TestArea.vue?vue&type=script&lang=js&"
export * from "./TestArea.vue?vue&type=script&lang=js&"
import style0 from "./TestArea.vue?vue&type=style&index=0&id=249083f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249083f7",
  null
  
)

export default component.exports